const htmldata = [
  {
    question: "How many levels of heading are in HTML",
    incorrectAnswers: ["3", "4", "5"],
    correctAnswer: "6",
  },
  {
    question: "Which of the following tags do not require a terminator?",
    incorrectAnswers: ["<u>", "<b>", "None"],
    correctAnswer: "<br>",
  },
  {
    question:
      "For a particular font its size attribute can be an absolute value ranging from",
    incorrectAnswers: ["1-9", "1-8", "1-7"],
    correctAnswer: "1-10",
  },
  {
    question:
      "Which one of the following tags is used to insert graphics in the webpage?",
    incorrectAnswers: ["<image>", "<images>", "<graphics>"],
    correctAnswer: "<img>",
  },
  {
    question:
      "The following html tag is used to display the content as a moving text",
    incorrectAnswers: ["None", "</img>", "<a href>"],
    correctAnswer: "<marquee>",
  },
  {
    question: "HTML comment should be enclosed between",
    incorrectAnswers: ["<! And !>", "<!— and –“”", "None"],
    correctAnswer: "<!– and — >",
  },
  {
    question:
      "Which element can be used to identify your html file to the outside world?",
    incorrectAnswers: ["title", "body", "head"],
    correctAnswer: "None",
  },
  {
    question: "HTML stands for?",
    incorrectAnswers: [
      "HighText Marking Language",
      "HyperText Machine Language",
      "HyperText Marking Language",
    ],
    correctAnswer: "HyperText Markup Language",
  },
  {
    question: "What is the correct syntax of doctype in HTML5?",
    incorrectAnswers: ["</doctype html>", "<doctype html>", "<doctype html!>"],
    correctAnswer: "<!doctype html>",
  },
  {
    question:
      "Which of the following tag is used for inserting the largest heading in HTML?",
    incorrectAnswers: ["head", "<h6>", "heading"],
    correctAnswer: "<h1>",
  },
  {
    question: "Which of the following is not a HTML5 tag?",
    incorrectAnswers: ["<track>", "<video>", "<source>"],
    correctAnswer: "<slider>",
  },
  {
    question: "How do we write comments in HTML?",
    incorrectAnswers: ["</…….>", "</……/>", "<…….!>"],
    correctAnswer: "<!……>",
  },
  {
    question:
      "In HTML, which attribute is used to create a link that opens in a new window tab?",
    incorrectAnswers: ["src=”_blank”", "alt=”_blank”", "target=”_self”"],
    correctAnswer: "target=”_blank”",
  },
  {
    question: "What is the work of <address> element in HTML5?",
    incorrectAnswers: [
      "contains IP address",
      "contains home address",
      "contains url",
    ],
    correctAnswer: "contains contact details for author",
  },
  {
    question: "What is the use of <hr/> tag in HTML?",
    incorrectAnswers: [
      "For making content appearance italics",
      "To create vertical rule between sections",
      "To create a line break",
    ],
    correctAnswer: "To create horizontal rule between sections",
  },
];

export default htmldata;
